module.exports = __webpack_public_path__ + "components/flag/static/square/do-d9544717dc372721a6484c74f4387724.svg";